import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TeamOverviewRowVm, TeamOverviewVm} from '../../models/team-dynamic.vm';

@Component({
  selector: 'app-team-overview',
  templateUrl: './team-overview.component.html',
  styleUrls: ['./team-overview.component.scss']
})
export class TeamOverviewComponent implements OnInit, OnChanges {
  private static readonly COLLAPSED_ROWS = 6;

  @Input() data: TeamOverviewVm | null = null;
  @Input() loading: boolean = false;

  visibleRows: TeamOverviewRowVm[] = [];
  showAll: boolean = false;
  hasHiddenRows: boolean = false;
  sortOptions: { label: string, value: string }[] = [];
  indicatorOptions: { label: string, value: string }[] = [];
  sortValue: string = 'overall';
  indicatorValue: string = 'lowest';

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setFilterPlaceholders();
    this.setVisibleRows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.showAll = false;
      this.setVisibleRows();
    }
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
    this.setVisibleRows();
  }

  trackByUuid(index: number, row: TeamOverviewRowVm) {
    return row.teamUuid ?? index;
  }

  private setVisibleRows() {
    const rows = this.data?.rows ?? [];
    this.hasHiddenRows = rows.length > TeamOverviewComponent.COLLAPSED_ROWS;
    this.visibleRows = this.showAll ? rows : rows.slice(0, TeamOverviewComponent.COLLAPSED_ROWS);
  }

  private setFilterPlaceholders() {
    this.sortOptions = [{label: this.translate.instant('td_team_overview_overall_column'), value: 'overall'}];
    this.indicatorOptions = [{label: this.translate.instant('td_team_overview_lowest_filter'), value: 'lowest'}];
  }
}
